import { SaturationVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { saturation } from '@cloudinary/url-gen/actions/adjust'
import { SliderField } from './SliderField'

export const SaturationVariant = (props: SaturationVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={-100}
        maxValue={100}
        step={1}
        pinnedValue={0}
        initialValue={variant.qualifier ?? 80}
        label="Adjust saturation"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(saturation(value))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'saturation', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
